const valueInRange = {
  methods: {
    // valueInRange: function (criteriaValue, range) {
    //   let result = true
    //   //const pricePatternStr = '(?:\\$|\\£|\\€)(?:[0-9]{1,3},(?:[0-9]{3},)*[0-9]{3}|[0-9]+)(?:\\s)?(?:\\.?[0-9][0-9])?'
    //   //const pricePattern = new RegExp(pricePatternStr, 'gmis')
    //   const numberPattern = /[0-9]+/g
    //   // console.log(`Finding numbers in ${criteriaValue}`)
    //   const normalizedValue = criteriaValue.replace(',', '').replace('.', ' ')
    //   // console.log(`Normalized = ${normalizedValue}`)
    //   const numbersFound = normalizedValue.match(numberPattern)
    //
    //   if (numbersFound) {
    //     // console.log(`Found numbers ${JSON.stringify(numbersFound)}`)
    //     let largestNumberStr = ''
    //     numbersFound.forEach(nextMatch => {
    //       if (nextMatch.length > largestNumberStr) {
    //         largestNumberStr = nextMatch
    //       }
    //     })
    //     if (largestNumberStr) {
    //       // console.log(`Found largestNumberStr ${largestNumberStr}`)
    //       const largestNumber = Number(largestNumberStr)
    //       const min = Number(range.min)
    //       const max = Number(range.max)
    //       // console.log(`Comparing ${largestNumber} with min:${min} max:${max}`)
    //       if (largestNumber < min || largestNumber > max) {
    //         // console.log(`@@@ ${largestNumber} not in range min:${min} max:${max}`)
    //         result = false
    //       }
    //     }
    //   }
    //   return result
    // },
    valueInRange: function (criteriaValue, range) {
      let result = true

      const largestNumber = this.valueAsLargestNumber(criteriaValue)

      if (largestNumber) {
        const min = Number(range.min)
        const max = Number(range.max)
        // console.log(`Comparing ${largestNumber} with min:${min} max:${max}`)
        if (largestNumber < min || largestNumber > max) {
          // console.log(`@@@ ${largestNumber} not in range min:${min} max:${max}`)
          result = false
        }
      }
      return result
    },
    valueAsLargestNumber: function (criteriaValue) {
      let result = null
      //const pricePatternStr = '(?:\\$|\\£|\\€)(?:[0-9]{1,3},(?:[0-9]{3},)*[0-9]{3}|[0-9]+)(?:\\s)?(?:\\.?[0-9][0-9])?'
      //const pricePattern = new RegExp(pricePatternStr, 'gmis')
      const numberPattern = /[0-9]+/g
      // console.log(`Finding numbers in ${criteriaValue}`)
      const normalizedValue = criteriaValue.replace(',', '').replace('.', ' ')
      // console.log(`Normalized = ${normalizedValue}`)
      const numbersFound = normalizedValue.match(numberPattern)

      if (numbersFound) {
        // console.log(`Found numbers ${JSON.stringify(numbersFound)}`)
        let largestNumberStr = ''
        numbersFound.forEach(nextMatch => {
          if (nextMatch.length > largestNumberStr) {
            largestNumberStr = nextMatch
          }
        })
        if (largestNumberStr) {
          // console.log(`Found largestNumberStr ${largestNumberStr}`)
          result = Number(largestNumberStr)
        }
      }
      return result
    }
  }
}

export default valueInRange
